import React, { useState } from "react";
import { log_error } from "../../../../api";

export default props => {
  const onClick = async e => {
    try {
      setLoading(true);
      await props.onClick(e);
    } catch (err) {
      log_error(err);
    } finally {
      setLoading(false);
    }
  };
  const [loading, setLoading] = useState(false);

  return (
    <button disabled={loading} onClick={e => onClick(e)} {...props}>
      {loading ? (
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
      ) : (
        props.children
      )}
    </button>
  );
};
